// import { ChartPie, History } from "assets/Icon";
import { Container, Grid } from "@mui/material";
import WalletTable from "./components/WalletTable";
import WalletCard from "../components/WalletCard";
// import { useNavigate, useSearchParams } from "react-router-dom";

import BackButton from "components/BackButton";
// import HeaderWallet from "./Component/HeaderWallet";
// import SpotCard from "./Component/Widgets/SpotCard";
// import TableSpot from "./components/WalletTable";
// import WalletTabs from "./Component/WalletTabs";
import useIsMobileView from "hooks/useIsMobileView";
import ButtonAction from "../components/ButtonAction";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function WalletPortfolio({ isBasket }) {
  const isMobileView = useIsMobileView();

  const portfolioWalletInfo = useSelector((state) => state.wallet.portfolioWalletInfo?.data)

  // eslint-disable-next-line no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  const actionItems = [
    {
      value: {
        key: "borrow",
        extra: { basketId: portfolioWalletInfo?.basketOwnerId },
      },
      text: "Borrow",
    },
    {
      value: {
        key: "repay",
        extra: { basketId: portfolioWalletInfo?.basketOwnerId },
      },
      text: "Repay"
    },
  ];



  const handleClickOnItems = (page) => {
    const defaultCoin = 1;
    setSearchParams({ [page?.key || page]: defaultCoin, ...page?.extra });
  };

  return (
    <Container maxWidth="100%">
      <Grid container spacing={2} mt={0}>
        {/* {isMobileView && <WalletTabs />} */}

        {/* <HeaderWallet itemHeader={itemHeader} /> */}

        {isMobileView && (
          <Grid item xs={12} >
            <BackButton text="Wallets" to="/wallet" />
          </Grid>
        )}

        <Grid item xs={12}>
          <WalletCard isBasket={isBasket} />
        </Grid>

        {
          isBasket &&
          <Grid item xs={12} my={2}>
            <ButtonAction items={actionItems} onChange={handleClickOnItems} />
          </Grid>
        }

        <Grid item xs={12}>
          <WalletTable isBasket={isBasket} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default WalletPortfolio;
